import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import RechnungEmpfangenSectionHeadersWhitePattern2 from '../components/headers-white-pattern/RechnungEmpfangenSectionHeadersWhitePattern2';
import RechnungEmpfangenSectionApplicationsWhitePattern6 from '../components/applications-white-pattern/RechnungEmpfangenSectionApplicationsWhitePattern6';
import RechnungEmpfangenSectionPricingWhitePattern8 from '../components/pricing-white-pattern/RechnungEmpfangenSectionPricingWhitePattern8';
import RechnungEmpfangenSection__elements9 from '../components/__elements/RechnungEmpfangenSection__elements9';
import RechnungEmpfangenSectionFootersGrayPattern5 from '../components/footers-gray-pattern/RechnungEmpfangenSectionFootersGrayPattern5';

const meta = {
  title: 'Rechnungen\u0020empfangen',
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function RechnungEmpfangen() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <RechnungEmpfangenSectionHeadersWhitePattern2 />
      <RechnungEmpfangenSectionApplicationsWhitePattern6 />
      <RechnungEmpfangenSectionPricingWhitePattern8 />
      <RechnungEmpfangenSection__elements9 />
      <RechnungEmpfangenSectionFootersGrayPattern5 />
    </React.Fragment>
  );
}

